import { BrowserRouter as Router } from 'react-router-dom';
import history from './../inits/history';
import BifrostRoutes from './BifrostRoutes';

const RenderRoutes = () => {
  return (
    <main>
      <Router history={history}>
        <BifrostRoutes />
      </Router>
    </main>
  );
};

export default RenderRoutes;

const FILE_VERSION = process.env.REACT_APP_FILE_VERSION;
